const xor = (a, b) => (a || b) && !(a && b);
export default xor;
